import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './icons'
import './utils/rem.js'
import axios from 'axios'
import 'bootstrap/dist/css/bootstrap.css'
import $ from 'jquery'
import config from './utils/config.js'
import 'bootstrap/dist/js/bootstrap.min.js'
import './styles/position.css'
import './styles/font.css';
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
import toastRegistry from './components/toast/index'
Vue.config.lanType=1
Vue.config.keyword={}
Vue.use(toastRegistry)
Vue.use(VideoPlayer)

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    axios.get(
      `${config.urlList.queryUrl}/api/cbh/settings`,
    ).then(res => {
      if(res.data.code==1){
        res.data.data.app_nameEn = res.data.data.app_nameEn?res.data.data.app_nameEn:res.data.data.app_name
        Vue.config.keyword={
          seo_keyword:res.data.data.app_name,
          seo_keyword_en:res.data.data.app_nameEn?res.data.data.app_nameEn:res.data.data.app_name
        }
        let str=Vue.config.lanType=='zh'?res.data.data.app_name:res.data.data.app_nameEn
        localStorage.setItem('CbhTitle', str);

        document.title = to.meta.title+' ' + str
      }
    })
  }
  next()
})
new Vue({
  router,
  store,
  $,
  render: function (h) { return h(App) }
}).$mount('#app')
